import axios from 'axios'

interface ProblemDetails {
  title?: string
  detail?: string
}

/**
 * Normalize an unknown error from an axios call into a user-facing string.
 *
 * The Sunny16 Commerce API currently returns a bare string body via
 * `BadRequest(ex.Message)` for handled exceptions, but model-binding failures
 * still produce a `ProblemDetails` object, and network failures have no
 * `response` at all. This helper covers all three.
 *
 * TODO: Once Sunny16 standardizes on `ProblemDetails` (or a typed envelope)
 * for all error responses, simplify this to read a single field.
 */
export function extractApiError(error: unknown, fallback: string): string {
  if (axios.isAxiosError<string | ProblemDetails>(error)) {
    const data = error.response?.data
    if (typeof data === 'string' && data.length > 0) return data
    if (data && typeof data === 'object') return data.detail ?? data.title ?? error.message
    return error.message
  }
  return error instanceof Error ? error.message : fallback
}
